import promise from 'es6-promise'

promise.polyfill()
import axios from 'axios'
import qs from 'qs'
import {Loading} from 'element-ui'

// axios 配置
// axios.defaults.baseURL = 'https://cctest.mychery.com:8081/' // 股份测试服务器
axios.defaults.baseURL = "https://cc.mychery.com:8081/"; //股份生产服务器 cc
// axios.defaults.baseURL = "https://cc2.mychery.com:8081/"; //股份生产服务器 cc2

//dms提供方式实现
// DMS 自动登录代理地址（cc-workorder 服务）：服务端代调 DMS 登录接口拿到
// Set-Cookie 后原样下发并 302 到 DMS 工作台，供 iframe / 新窗口导航使用
// export const dmsAutoLoginUrl = axios.defaults.baseURL + 'cc-workorder/api/v1/dms/autoLogin'

axios.defaults.withCredentials = false
if (JSON.parse(sessionStorage.getItem('userinfo') != null)) {
  axios.defaults.headers = {
    // 'X-Requested-With': 'XMLHttpRequest',
    'Connection': 'keep-alive',
    'Content-Type': 'application/x-www-form-urlencoded',
  }
}
const options = {
  lock: true, // 是否锁屏
  text: '载入中...', // 加载动画的文字
  background: 'rgba(0, 0, 0, 0.3)', // 背景颜色
  target: '.main-container', // 需要遮罩的区域
  body: true,
  customClass: 'mask' // 遮罩层新增类名
}

export const instance = axios.create()

export function axiosData4 (url, method, data) {
  let loadingInstance = Loading.service(options)
  return new Promise((resolve, reject) => {
    var json
    if (method === 'get') {
      json = {
        params: qs.stringify(data)
      }
    } else if (method === 'post') {
      json = qs.stringify(data)
    }
    let userToken = sessionStorage.getItem('userToken');
    let CurrAuth= window.location.href;
    instance[method](url, {
      timeout: 60 * 1000 * 5,
      responseType: method.toLowerCase() === 'get' ? 'blob' : 'json',
      headers:{
        AuthUserToken:userToken,
        CurrAuth :CurrAuth
      }
    }, json)
      .then(res => {
        loadingInstance.close()
        resolve(res.data)
      })
      .catch(res => {
        loadingInstance.close()
        reject(res)
      })
  })
}

export function axiosData3 (url, method, data, config) {
  return new Promise((resolve, reject) => {
    var json
    if (method === 'get') {
      json = {
        params: qs.stringify(data)
      }
    } else if (method === 'post') {
      json = qs.stringify(data)
    }
    let userToken = sessionStorage.getItem('userToken');
    let CurrAuth= window.location.href;
    instance[method](url, json, {
      timeout: 60 * 1000 * 5,
      responseType: method === 'get' ? 'blob' : 'json',
      headers:{
        AuthUserToken:userToken,
        CurrAuth :CurrAuth
      }
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(res => {
        reject(res)
      })
  })
}

export function axiosData2 (url, method, data, config) {
  let loadingInstance = Loading.service(options)

  return new Promise((resolve, reject) => {
    var json
    if (method === 'get') {
      json = {
        params: qs.stringify(data)
      }
    } else if (method === 'post') {
      json = qs.stringify(data)
    }

    let userToken = sessionStorage.getItem('userToken');
    let CurrAuth= window.location.href;
    instance[method](url, json, {
      timeout: 60 * 1000 * 5,
      responseType: method === 'get' ? 'blob' : 'json',
      headers:{
        AuthUserToken:userToken,
        CurrAuth :CurrAuth
      }
    })
      .then(res => {
        loadingInstance.close()
        resolve(res.data)
      })
      .catch(res => {
        loadingInstance.close()
        reject(res)
      })
  })
}

export function axiosData (url, method, data, config) {
  let loadingInstance = Loading.service(options)
  return new Promise((resolve, reject) => {
    var json
    if (method === 'get') {
      json = {
        params: qs.stringify(data)
      }
    } else if (method === 'post') {
      json = qs.stringify(data)
    }

    let userToken = sessionStorage.getItem('userToken');
    let CurrAuth= window.location.href;
    instance[method](url, json, {
      timeout: 60 * 1000 * 5,
      responseType: method === 'get' ? 'blob' : 'json',
      headers:{
        AuthUserToken:userToken,
        CurrAuth :CurrAuth
      }
    })
      .then(res => {
        loadingInstance.close()
        resolve(res.data)
      })
      .catch(res => {
        reject(res)
        loadingInstance.close()
      })
  })
}

export const allApis = {
  //登录接口
  login (data) {
    return axiosData('cc-user/api/v1/auth/login', data.type, data.data)
  },

  //更新用户常用功能
  updateOffenUse (data) {
    return axiosData(
      'cc-user/api/v1/auth/updateUserCommonMenus',
      data.type,
      data.data
    )
  },

  //用户操作日志
  userOperationLog (data) {
    return axiosData(
      'cc-user/api/v1/users/userOperationLog',
      data.type,
      data.data
    )
  },

  //软电话登录日志
  recordLoginLog (data) {
    return axiosData(
      'cc-user/api/v1/users/recordLoginLog',
      data.type,
      data.data
    )
  },

  //部门下拉
  department (data) {
    return axiosData(
      'cc-user/api/v1/department/getDepartmentList',
      data.type,
      data.data
    )
  },

  //用户查询
  getuserList (data) {
    return axiosData('cc-user/api/v1/users/getUserList', data.type, data.data)
  },

  //用户导出
  download (data) {
    return axiosData('cc-user/api/v1/users/download', data.type, data.data)
  },

  //部门接口
  getCheryDepartmentList (data) {
    return axiosData(
      'cc-user/api/v1/department/getCheryDepartmentList',
      data.type,
      data.data
    )
  },

  //用户导入
  importFile (data) {
    return axiosData('cc-user/api/v1/users/importFile', data.type, data.data)
  },

  //权限显示
  getAuthorityList (data) {
    return axiosData(
      'cc-user/api/v1/role/getAuthorityList',
      data.type,
      data.data
    )
  },

  //登录页面修改密码
  loginPageChangePw (data) {
    return axiosData(
      'cc-user/api/v1/auth/updatePassword',
      data.type,
      data.data
    )
  },

  //权限配置
  rightsManagement (data) {
    return axiosData(
      'cc-user/api/v1/role/rightsManagement',
      data.type,
      data.data
    )
  },

  //角色查询
  getRoles (data) {
    return axiosData('cc-user/api/v1/role/getRoles', data.type, data.data)
  },

  //角色新建
  createRoles (data) {
    return axiosData('cc-user/api/v1/role/createRoles', data.type, data.data)
  },

  //修改密码
  updateOriginalPassword (data) {
    return axiosData(
      'cc-user/api/v1/users/updateOriginalPassword',
      data.type,
      data.data
    )
  },

  //增加业务部门
  addSysDepartmentList (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/addSysDepartmentList',
      data.type,
      data.data
    )
  },

  //角色修改
  updateRoleName (data) {
    return axiosData(
      'cc-user/api/v1/role/updateRoleName',
      data.type,
      data.data
    )
  },

  //角色分配
  permissionsIsChooseUser (data) {
    return axiosData(
      'cc-user/api/v1/role/permissionsIsChooseUser',
      data.type,
      data.data
    )
  },

  //号码归属地
  getPhoneLocation (data) {
    return axiosData2(
      'cc-user/api/v1/common/getPhoneLocation',
      data.type,
      data.data
    )
  },

  //号码归属地
  getPhoneLocation2 (data) {
    return axiosData2(
      'cc-user/api/v1/common/getPhoneLocation2',
      data.type,
      data.data
    )
  },

  //下拉框
  groupingList (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/groupingList',
      data.type,
      data.data
    )
  },

  //首页数量
  getSeatsInfo (data) {
    return axiosData(
      'cc-user/api/v1/common/getSeatsInfo',
      data.type,
      data.data
    )
  },

  //新增工单管理岗位
  addManagementPositionList (data) {
    return axiosData(
      'cc-user/api/v1/config/addManagementPositionList',
      data.type,
      data.data
    )
  },

  updateWorkOrderPlanArriveTime (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/updateWorkOrderPlanArriveTime',
      data.type,
      data.data
    )
  },

  //终端差评查询
  getWorkordersTempList (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/getWorkordersTempList',
      data.type,
      data.data
    )
  },

  //终端差评临时表清空
  delWorkorderTemp (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/delWorkorderTemp',
      data.type,
      data.data
    )
  },

  //终端差评临时表确认派发
  confirmDistribution (data) {
    return axiosData3(
      'cc-workorder/api/v1/workorder/complaintConfirmDistribution',
      data.type,
      data.data
    )
  },

  //来电弹屏，工单来源判断
  getConfigSimpleId (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/getConfigSimpleId',
      data.type,
      data.data
    )
  },

  //抱怨工单申请支持提醒
  startIntelligentFill (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/startIntelligentFill',
      data.type,
      data.data
    )
  },

  getIntelligentFillResult (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/getIntelligentFillResult',
      data.type,
      data.data
    )
  },

  getCustomerAssistantRasrEvents (data) {
    return axiosData3(
      'cc-workorder/api/v1/workorder/getCustomerAssistantRasrEvents',
      data.type,
      data.data
    )
  },

  getCustomerAssistantKnowledgeEvents (data) {
    return axiosData3(
      'cc-workorder/api/v1/workorder/getCustomerAssistantKnowledgeEvents',
      data.type,
      data.data
    )
  },

  getBusinessSupport (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/getBusinessSupport',
      data.type,
      data.data
    )
  },

  sendAreaNotice (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/sendAreaNotice',
      data.type,
      data.data
    )
  },

  // 转交大区下拉列表查询
  getTransferAreaList (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/getAreaList',
      data.type,
      data.data
    )
  },

  //改派工单
  reassignmentDealer (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/reassignmentDealer',
      data.type,
      data.data
    )
  },

  //城市列表
  getCityMap (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/getCityMap',
      data.type,
      data.data
    )
  },

  //城市列表-无遮罩
  getCityMapNoShadow (data) {
    return axiosData3(
      'cc-workorder/api/v1/workorder/getCityMap',
      data.type,
      data.data
    )
  },

  //可选人员分配
  assignPermissions (data) {
    return axiosData(
      'cc-user/api/v1/role/assignPermissions',
      data.type,
      data.data
    )
  },

  //退出登录
  outLogin (data) {
    return axiosData('cc-user/api/v1//auth/outLogin', data.type, data.data)
  },

  //主机厂列表
  getSysDepartmentList (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/getSysDepartmentList',
      data.type,
      data.data
    )
  },

  //部门列表
  getGroupingList (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/getGroupingList',
      data.type,
      data.data
    )
  },

  //保存部门分组
  addGrouping (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/addGrouping',
      data.type,
      data.data
    )
  },

  //删除部门分组
  delGrouping (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/delGrouping',
      data.type,
      data.data
    )
  },

  //通知提醒
  updateNoticeReadByUserID (data) {
    return axiosData(
      'cc-user/api/v1/notice/updateNoticeReadByUserID',
      data.type,
      data.data
    )
  },

  //部门成员列表
  getDepartmentMembersList (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/getDepartmentMembersList',
      data.type,
      data.data
    )
  },

  //部门成员列表
  getDepartmentMembersListOuther (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/getDepartmentMembersListOuther',
      data.type,
      data.data
    )
  },

  //添加成员列表
  getSysDepartmentPersonList (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/getSysDepartmentPersonList',
      data.type,
      data.data
    )
  },

  //部门添加成员
  addDepartmentMembers (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/addDepartmentMembers',
      data.type,
      data.data
    )
  },

  //删除成员
  delDepartmentMembers (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/delDepartmentMembers',
      data.type,
      data.data
    )
  },

  //转交部门
  getOtherTransferComplaintDepartment (data) {
    return axiosData(
      'cc-user/api/v1/config/getOtherTransferComplaintDepartment',
      data.type,
      data.data
    )
  },

  //任务默认问卷列表
  taskQuestionnaireConfiguration (data) {
    return axiosData(
      'cc-user/api/v1/config/taskQuestionnaireConfiguration',
      data.type,
      data.data
    )
  },

  //修改工单传播部
  updateWorkorderPropagationMailbox (data) {
    return axiosData(
      'cc-user/api/v1/config/updateWorkorderPropagationMailbox',
      data.type,
      data.data
    )
  },

  //设置默认问卷列表
  setTaskQuestionnaireConfiguration (data) {
    return axiosData(
      'cc-user/api/v1/config/setTaskQuestionnaireConfiguration',
      data.type,
      data.data
    )
  },

  //工单业务分类配置
  getFirstBusinessType (data) {
    return axiosData(
      'cc-user/api/v1/config/getFirstBusinessType',
      data.type,
      data.data
    )
  },

  //品牌流水线
  getBrandLines (data) {
    return axiosData(
      'cc-user/api/v1/config/getBrandLines',
      data.type,
      data.data
    )
  },

  //工单业务一级分配
  firstClassification (data) {
    return axiosData2(
      'cc-user/api/v1/config/firstClassification',
      data.type,
      data.data
    )
  },

  //工单业务二级级分配
  secondOrThirdClassification (data) {
    return axiosData2(
      'cc-user/api/v1/config/secondOrThirdClassification',
      data.type,
      data.data
    )
  },

  //工单二级业务分类配置
  getSecondBusinessType (data) {
    return axiosData(
      'cc-user/api/v1/config/getSecondBusinessType',
      data.type,
      data.data
    )
  },

  //工单三级业务分类配置
  getThirdBusinessType (data) {
    return axiosData(
      'cc-user/api/v1/config/getThirdBusinessType',
      data.type,
      data.data
    )
  },

  //工单重大标记
  getImportantFlagList (data) {
    return axiosData(
      'cc-user/api/v1/config/getImportantFlagList',
      data.type,
      data.data
    )
  },

  //外呼小结列表
  summaryStateList (data) {
    return axiosData(
      'cc-user/api/v1/config/summaryStateList',
      data.type,
      data.data
    )
  },

  //删除外呼小结
  delSummaryState (data) {
    return axiosData(
      'cc-user/api/v1/config/delSummaryState',
      data.type,
      data.data
    )
  },

  //新增外呼小结
  insertSummaryState (data) {
    return axiosData(
      'cc-user/api/v1/config/insertSummaryState',
      data.type,
      data.data
    )
  },

  getLeadFirstClassificationList (data) {
    return axiosData(
      'cc-user/api/v1/config/getLeadFirstClassificationList',
      data.type,
      data.data
    )
  },

  getLeadSecondClassificationList (data) {
    return axiosData(
      'cc-user/api/v1/config/getLeadSecondClassificationList',
      data.type,
      data.data
    )
  },

  //抱怨级别下拉框
  getGrumbleLevel (data) {
    return axiosData(
      'cc-user/api/v1/config/getGrumbleLevel',
      data.type,
      data.data
    )
  },

  //抱怨级别下拉框
  getGrumbleLevelList (data) {
    return axiosData(
      'cc-user/api/v1/config/getGrumbleLevelList',
      data.type,
      data.data
    )
  },

  //抱怨转交部门下拉框
  getTransferComplaintDepartmentList (data) {
    return axiosData2(
      'cc-user/api/v1/config/getTransferComplaintDepartmentList',
      data.type,
      data.data
    )
  },

  //删除抱怨级别
  delGrumbleLevel (data) {
    return axiosData(
      'cc-user/api/v1/config/delGrumbleLevel',
      data.type,
      data.data
    )
  },

  //新增抱怨级别
  createGrumbleLevel (data) {
    return axiosData(
      'cc-user/api/v1/config/createGrumbleLevel',
      data.type,
      data.data
    )
  },

  //抱怨转交部门
  getTransferComplaintDepartment (data) {
    return axiosData(
      'cc-user/api/v1/config/getTransferComplaintDepartment',
      data.type,
      data.data
    )
  },

  //抱怨转交部门保存
  createTransferComplaintDepartment (data) {
    return axiosData(
      'cc-user/api/v1/config/createTransferComplaintDepartment',
      data.type,
      data.data
    )
  },

  //线索分类列表
  leadClassificationList (data) {
    return axiosData(
      'cc-user/api/v1/config/leadClassificationList',
      data.type,
      data.data
    )
  },

  //新建线索分类
  addLeadClassification (data) {
    return axiosData(
      'cc-user/api/v1/config/addLeadClassification',
      data.type,
      data.data
    )
  },

  //删除线索分类
  delLeadClassification (data) {
    return axiosData(
      'cc-user/api/v1/config/delLeadClassification',
      data.type,
      data.data
    )
  },

  //线索分类/线索等级下拉框
  leadClassificationByParentIdList (data) {
    return axiosData2(
      'cc-user/api/v1/config/leadClassificationByParentIdList',
      data.type,
      data.data
    )
  },

  //线索分类/线索等级下拉框
  leadClassificationByParentIdList2 (data) {
    return axiosData(
      'cc-user/api/v1/config/leadClassificationByParentIdList',
      data.type,
      data.data
    )
  },

  //线索来源
  leadChannelsOneList (data) {
    return axiosData(
      'cc-user/api/v1/config/leadChannelsOneList',
      data.type,
      data.data
    )
  },

  //抱怨转交部门删除
  delTransferComplaintDepartment (data) {
    return axiosData(
      'cc-user/api/v1/config/delTransferComplaintDepartment',
      data.type,
      data.data
    )
  },

  //工单重大标记添加
  addImportantFlagList (data) {
    return axiosData(
      'cc-user/api/v1/config/addImportantFlagList',
      data.type,
      data.data
    )
  },

  //工单重大标记删除
  delImportantFlagList (data) {
    return axiosData(
      'cc-user/api/v1/config/delImportantFlagList',
      data.type,
      data.data
    )
  },

  //工单重大标记删除
  delImportantFlagList (data) {
    return axiosData(
      'cc-user/api/v1/config/delImportantFlagList',
      data.type,
      data.data
    )
  },

  //工单主诉模板
  getComplaintTemplateList (data) {
    return axiosData(
      'cc-user/api/v1/config/getComplaintTemplateList',
      data.type,
      data.data
    )
  },

  //添加主诉模板
  createComplaintTemplateList (data) {
    return axiosData(
      'cc-user/api/v1/config/createComplaintTemplateList',
      data.type,
      data.data
    )
  },

  //删除主诉模板
  delComplaintTemplateList (data) {
    return axiosData(
      'cc-user/api/v1/config/delComplaintTemplateList',
      data.type,
      data.data
    )
  },

  //线索二级分类列表
  leadSecondClassificationList (data) {
    return axiosData(
      'cc-user/api/v1/config/leadSecondClassificationList',
      data.type,
      data.data
    )
  },

  //工单管理岗位列表
  getManagementPositionList (data) {
    return axiosData(
      'cc-user/api/v1/config/getManagementPositionList',
      data.type,
      data.data
    )
  },

  // 新车型公告号配置列表
  getNewCarTypeAnnouncementNo (data) {
    return axiosData(
      'cc-user/api/v1/config/getNewCarTypeAnnouncementNo',
      data.type,
      data.data
    )
  },
  // 删除新车型公告号配置
  delNewCarTypeAnnouncementNo (data) {
    return axiosData(
      'cc-user/api/v1/config/delNewCarTypeAnnouncementNo',
      data.type,
      data.data
    )
  },
  // 新增新车型公告号配置
  insertNewCarTypeAnnouncementNo (data) {
    return axiosData(
      'cc-user/api/v1/config/insertNewCarTypeAnnouncementNo',
      data.type,
      data.data
    )
  },

  // 重点车型公告号配置列表
  getKeyModelsAnnouncementNo (data) {
    return axiosData(
      'cc-user/api/v1/config/getKeyModelsAnnouncementNo',
      data.type,
      data.data
    )
  },
  // 删除重点车型公告号
  delKeyModelsAnnouncementNo (data) {
    return axiosData(
      'cc-user/api/v1/config/delKeyModelsAnnouncementNo',
      data.type,
      data.data
    )
  },
  // 新增重点车型公告号配置
  insertKeyModelsAnnouncementNo (data) {
    return axiosData(
      'cc-user/api/v1/config/insertKeyModelsAnnouncementNo',
      data.type,
      data.data
    )
  },
  // 公关传播部邮箱配置列表
  getWorkorderPropagationMailbox (data) {
    return axiosData(
      'cc-user/api/v1/config/getWorkorderPropagationMailbox',
      data.type,
      data.data
    )
  },
  // 编辑公关传播部邮箱
  insertWorkorderPropagationMailbox (data) {
    return axiosData(
      'cc-user/api/v1/config/insertWorkorderPropagationMailbox ',
      data.type,
      data.data
    )
  },
  // // 编辑公关传播部邮箱
  // insertWorkorderPropagationMailbox (data) {
  //   return axiosData('cc-user/api/v1/config/updateWorkorderPropagationMailbox ', data.type, data.data)
  // },

  // 删除传播部邮箱配置
  delWorkorderPropagationMailbox (data) {
    return axiosData(
      'cc-user/api/v1/config/delWorkorderPropagationMailbox',
      data.type,
      data.data
    )
  },

  // 工单显示--故障分类一级分类列表
  getMalTypeOne (data) {
    return axiosData(
      'cc-user/api/v1/config/getMalTypeOne',
      data.type,
      data.data
    )
  },


  // 工单显示--故障分类二级分类列表
  getMalTypeTwo (data) {
    return axiosData(
      'cc-user/api/v1/config/getMalTypeTwo',
      data.type,
      data.data
    )
  },

  // 配置项--故障分类一级分类列表
  getFirstMalType (data) {
    return axiosData(
      'cc-user/api/v1/config/getFirstMalType',
      data.type,
      data.data
    )
  },


  // 配置项--故障分类二级分类列表
  getSecondMalType (data) {
    return axiosData(
      'cc-user/api/v1/config/getSecondMalType',
      data.type,
      data.data
    )
  },

  //配置项--删除故障分类
  delMalType (data) {
    return axiosData(
      'cc-user/api/v1/config/delMalType',
      data.type,
      data.data
    )
  },

  //配置项--新增故障分类
  createMalType (data) {
    return axiosData(
      'cc-user/api/v1/config/createMalType',
      data.type,
      data.data
    )
  },


  //删除分类
  delBusinessType (data) {
    return axiosData(
      'cc-user/api/v1/config/delBusinessType',
      data.type,
      data.data
    )
  },

  //新增分类
  createBusinessType (data) {
    return axiosData(
      'cc-user/api/v1/config/createBusinessType',
      data.type,
      data.data
    )
  },

  //获取验证码
  obtcode (data) {
    return axiosData2('cc-user/api/v1/auth/obtcode', data.type, data.data)
  },

  //已选人员分配
  reducesAsignPermissions (data) {
    return axiosData(
      'cc-user/api/v1/role/reducesAsignPermissions',
      data.type,
      data.data
    )
  },

  // 备件列表下载模板
  PartsPriceImportExcel (data) {
    return axiosData(
      'cc-profile/api/v1/mdm/downloadMdmComponentpriceExcel' + data.params,
      data.type,
      data.data
    )
  },

  //红黑名单导出
  exportExcelDate (data) {
    return axiosData(
      'cc-user/api/v1/sys/exportExcelDate' + data.params,
      data.type,
      data.data
    )
  },

  //获取vip车型
  getVipCarType (data) {
    return axiosData('cc-user/api/v1/sys/getVipCarType', data.type, data.data)
  },

  //设置vip车型
  addVipCarType (data) {
    return axiosData('cc-user/api/v1/sys/addVipCarType', data.type, data.data)
  },

  //查询红黑名单
  customerAndPhonList (data) {
    return axiosData(
      'cc-user/api/v1/sys/customerAndPhonList',
      data.type,
      data.data
    )
  },

  //红黑名单导入
  importExcel (data) {
    return axiosData('cc-user/api/v1/sys/importExcel', data.type, data.data)
  },

  //红黑名单导出模板
  exportExcelTalbe (data) {
    return axiosData(
      'cc-user/api/v1/sys/exportExcelTalbe' + data.params,
      data.type,
      data.data
    )
  },

  //删除
  deleteData (data) {
    return axiosData('cc-user/api/v1/sys/deleteData', data.type, data.data)
  },

  //岗位查询
  getPositionName (data) {
    return axiosData(
      'cc-user/api/v1/position/getPositionName',
      data.type,
      data.data
    )
  },

  //服务商导入
  downloadExcel (data) {
    return axiosData(
      'cc-user/api/v1/dealers/downloadExcel',
      data.type,
      data.data
    )
  },

  //详情
  getDealerInfo (data) {
    return axiosData(
      'cc-user/api/v1/dealers/getDealerInfo',
      data.type,
      data.data
    )
  },

  //修改状态
  updateleaveApply (data) {
    return axiosData(
      'cc-user/api/v1/dealers/updateleaveApply',
      data.type,
      data.data
    )
  },

  //用户添加
  Userinsert (data) {
    return axiosData('cc-user/api/v1/users/insert', data.type, data.data)
  },

  //用户修改
  updateUser (data) {
    return axiosData('cc-user/api/v1/users/updateUser', data.type, data.data)
  },

  //角色接口
  getRole (data) {
    return axiosData('cc-user/api/v1/role/getRole', data.type, data.data)
  },

  //修改成员信息 --建议工单是否展示
  updateShowAdvise (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/updateShowAdvise',
      data.type,
      data.data
    )
  },
  //修改成员信息
  updateDepartmentMembers (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/updateDepartmentMembers',
      data.type,
      data.data
    )
  },

  //修改成员》大区信息
  updateDepartmentMembersOuther (data) {
    return axiosData(
      'cc-user/api/v1/SysDepartment/updateDepartmentMembersOuther',
      data.type,
      data.data
    )
  },

  //品牌接口
  getBrandList (data) {
    return axiosData('cc-user/api/v1/users/getBrandList', data.type, data.data)
  },

  //子品牌列表
  getChildBrandList (data) {
    return axiosData(
      'cc-user/api/v1/users/getChildBrandList',
      data.type,
      data.data
    )
  },

  //角色修改
  setRole (data) {
    return axiosData('cc-user/api/v1/users/setRole', data.type, data.data)
  },

  //修改密码
  updatePassword (data) {
    return axiosData(
      'cc-user/api/v1/users/updatePassword',
      data.type,
      data.data
    )
  },

  //离职（删除主机厂账号）
  delMainUser (data) {
    return axiosData(
      'cc-user/api/v1/users/delMainUser',
      data.type,
      data.data
    )
  },

  //消息通知
  getListByUser (data) {
    return axiosData(
      'cc-user/api/v1/notice/getListByUser',
      data.type,
      data.data
    )
  },

  //数字字典
  Dictionaries (data) {
    return axiosData(
      'cc-profile/api/v1/profile/dictionary/list',
      data.type,
      data.data
    )
  },

  //人车关系临时新增用户
  addTempUser (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/insertTemporaryCust',
      data.type,
      data.data
    )
  },

  //弹框
  getUserNoticeList (data) {
    return axiosData3(
      'cc-user/api/v1/notice/getUserNoticeList',
      data.type,
      data.data
    )
  },

  //获取市区无遮罩
  provinceListB (data) {
    return axiosData3(
      'cc-profile/api/v1/profile/customer/province',
      data.type,
      data.data
    )
  },

  //获取市区
  provinceList (data) {
    return axiosData2(
      'cc-profile/api/v1/profile/customer/province',
      data.type,
      data.data
    )
  },

  //获取市区
  provinceListA (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/province',
      data.type,
      data.data
    )
  },

  //合并
  mergeCustomer (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/mergeCustomer',
      data.type,
      data.data
    )
  },

  //获取市区
  cityAndAreaList (data) {
    return axiosData2(
      'cc-profile/api/v1/profile/customer/cityAndAreaList',
      data.type,
      data.data
    )
  },

  //客户档案
  CustomerArchives (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/info',
      data.type,
      data.data
    )
  },

  //新增临时车辆
  addCars (data) {
    return axiosData(
      'cc-profile/api/v1/profile/car/addTemporaryCar',
      data.type,
      data.data
    )
  },

  getMaintenancesOrder (data) {
    return axiosData(
      'cc-profile/api/v1/profile/car/getMaintenancesOrder',
      data.type,
      data.data
    )
  },

  //联系人
  queryCustomerList (data) {
    return axiosData2(
      'cc-profile/api/v1/sendrecord/queryCustomerList',
      data.type,
      data.data
    )
  },

  //根据vin获取车和车主信息
  getInfoByVIN (data) {
    return axiosData(
      'cc-profile/api/v1/profile/car/getCarAndCustomer',
      data.type,
      data.data
    )
  },

  //客户档案列表
  CustomerArchivesList (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/list',
      data.type,
      data.data
    )
  },

  //大区
  areas (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/areas',
      data.type,
      data.data
    )
  },

  //客户工单
  customerOrderList (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/getWorkorders',
      data.type,
      data.data
    )
  },

  //工单类型状态联动
  orderTypeAndStatus (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/workTypeStatusList',
      data.type,
      data.data
    )
  },

  //工单类型回访状态联动
  orderTypeAndCallBackStatus (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/getWorktypecallbackstatusmap',
      data.type,
      data.data
    )
  },

  //客户线索
  customerLeadList (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/custLeads',
      data.type,
      data.data
    )
  },

  //获取短信内容
  getCustomerInteractionlogs (data) {
    return axiosData(
      'cc-profile/api/v1/sendrecord/querySmsSendRecordById',
      data.type,
      data.data
    )
  },

  //设置车主/送修人
  changeRelation (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/changeRelation',
      data.type,
      data.data
    )
  },

  //车辆档案列表
  getCarList (data) {
    return axiosData(
      'cc-profile/api/v1/profile/car/getCarList',
      data.type,
      data.data
    )
  },

  //车辆档案信息
  customerCarList (data) {
    return axiosData(
      'cc-profile/api/v1/profile/car/customerCarList',
      data.type,
      data.data
    )
  },

  //客户档案修改历史
  getIfsProfilemodification (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/getIfsProfilemodification',
      data.type,
      data.data
    )
  },

  //车辆档案修改历史
  getUpdateCarHistory (data) {
    return axiosData(
      'cc-profile/api/v1/profile/car/getUpdateCarHistory',
      data.type,
      data.data
    )
  },

  //获取车辆详情
  getCarInfo (data) {
    return axiosData(
      'cc-profile/api/v1/profile/car/getCarInfo',
      data.type,
      data.data
    )
  },

  //修改车辆信息
  updateCarInfo (data) {
    return axiosData(
      'cc-profile/api/v1/profile/car/updateCarInfo',
      data.type,
      data.data
    )
  },

  // 客户档案》沟通历史弹窗，查询
  communicationHistoryListDialog (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/getCustomerInteractionlogs',
      data.type,
      data.data
    )
  },

  //沟通历史列表
  communicationHistoryList (data) {
    return axiosData(
      'cc-task/api/v1/CommunicateHistoryController/selectCustomerInteractionlogsList',
      data.type,
      data.data
    )
  },

  //客户档案--沟通历史列表--导出
  exportCommunicationHistoryList (data) {
    return axiosData4(
      'cc-profile/api/v1/profile/exportCommunicationHistoryList' + data.params,
      data.type,
      data.data
    )
  },
  //客户档案--沟通历史列表--全部导出
  exportAllCommunicationHistoryList (data) {
    return axiosData4(
      'cc-profile/api/v1/profile/exportAllCommunicationHistoryList' + data.params,
      data.type,
      data.data
    )
  },
  //获取语音
  getVoice (data) {
    return axiosData(
      'http://10.2.14.150:13581/downRecording',
      data.type,
      data.data
    )
  },

  //销售经销商列表
  queryDealersList (data) {
    return axiosData(
      'cc-profile/api/v1/sendrecord/queryDealersList',
      data.type,
      data.data
    )
  },

  //客户档案修改
  updateCustInfo (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/updateCustInfo',
      data.type,
      data.data
    )
  },

  //获取客户相关车辆
  vehicles (data) {
    return axiosData(
      'cc-profile/api/v1/profile/customer/vehicles',
      data.type,
      data.data
    )
  },

  //跑马灯列表
  marqueesList (data) {
    return axiosData(
      'cc-user/api/v1/marquees/marqueesList',
      data.type,
      data.data
    )
  },

  //新增跑马灯
  addMarquees (data) {
    return axiosData(
      'cc-user/api/v1/marquees/addMarquees',
      data.type,
      data.data
    )
  },

  //删除跑马灯
  deleteMarquees (data) {
    return axiosData(
      'cc-user/api/v1/marquees/deleteMarquees',
      data.type,
      data.data
    )
  },

  //修改跑马灯
  updateMarquees (data) {
    return axiosData(
      'cc-user/api/v1/marquees/updateMarquees',
      data.type,
      data.data
    )
  },

  //点击申请离席
  addLeaveApply (data) {
    return axiosData(
      'cc-user/api/v1/dealers/addLeaveApply',
      data.type,
      data.data
    )
  },

  //离席申请小标
  updateNoticeReadByRelatedID (data) {
    return axiosData(
      'cc-user/api/v1//notice/updateNoticeReadByRelatedID',
      data.type,
      data.data
    )
  },

  //待处理小标
  updateMsgCntByRelatedID (data) {
    return axiosData(
      'cc-user/api/v1//notice/updateMsgCntByRelatedID',
      data.type,
      data.data
    )
  },

  //离席申请集合
  leaveApplyState (data) {
    return axiosData(
      'cc-user/api/v1/dealers/leaveApplyState',
      data.type,
      data.data
    )
  },

  //客户主诉模板
  chooseComplaintTemplate (data) {
    return axiosData2(
      'cc-user/api/v1/config/chooseComplaintTemplate',
      data.type,
      data.data
    )
  },

  //重大标记
  getImportantFlag (data) {
    return axiosData2(
      'cc-user/api/v1/config/getImportantFlag',
      data.type,
      data.data
    )
  },

  //使用车型接口
  queryCarType (data) {
    return axiosData(
      'cc-user/api/v1/dealers/queryCarType',
      data.type,
      data.data
    )
  },

  //车型详情接口
  carTypeDetails (data) {
    return axiosData(
      'cc-profile/api/v1/mdm/getCartypematerialDeatil',
      data.type,
      data.data
    )
  },

  //车型详情修改接口
  carTypeDetailsChange (data) {
    return axiosData(
      'cc-profile/api/v1/mdm/updateCartypematerial',
      data.type,
      data.data
    )
  },

  //车型删除接口
  carTypeDelete (data) {
    return axiosData(
      'cc-profile/api/v1/mdm/delCartypematerial',
      data.type,
      data.data
    )
  },

  //工位列表
  workPositionsList (data) {
    return axiosData(
      'cc-user/api/v1/workpositions/workPositionsList',
      data.type,
      data.data
    )
  },

  //新增工位
  addWorkPositions (data) {
    return axiosData(
      'cc-user/api/v1/workpositions/addWorkPositions',
      data.type,
      data.data
    )
  },

  //修改通讯录详情
  updateDealers (data) {
    return axiosData('cc-user/api/v1/dealers/upDealer', data.type, data.data)
    // return axiosData('cc-user/api/v1/dealers/updateDealers', data.type, data.data)
  },

  // 通讯录手动录入
  adddealers (data) {
    return axiosData('cc-user/api/v1/dealers/addDealer', data.type, data.data)
  },

  //通讯录手动录入获取大区
  getSysAreasList (data) {
    return axiosData(
      'cc-user/api/v1/dealers/getSysAreasList',
      data.type,
      data.data
    )
  },

  //删除工位
  deleteWorkPositions (data) {
    return axiosData(
      'cc-user/api/v1/workpositions/deleteWorkPositions',
      data.type,
      data.data
    )
  },

  //修改工位
  updateWorkPositions (data) {
    return axiosData(
      'cc-user/api/v1/workpositions/updateWorkPositions',
      data.type,
      data.data
    )
  },

  //添加小结
  insertSummaryState (data) {
    return axiosData(
      'cc-user/api/v1/config/insertSummaryState',
      data.type,
      data.data
    )
  },

  //线索三级分类
  leadThirdClassificationList (data) {
    return axiosData(
      'cc-user/api/v1/config/leadThirdClassificationList',
      data.type,
      data.data
    )
  },

  //查询通讯录
  findDealers (data) {
    return axiosData(
      'cc-user/api/v1/dealers/findDealers',
      data.type,
      data.data
    )
  },

  //查询通讯录最新导入操作时间
  lastImportT (data) {
    return axiosData(
      'cc-user/api/v1/dealers/getDealerTime',
      data.type,
      data.data
    )
  },

  //查询车型
  cartypematerial (data) {
    return axiosData(
      'cc-profile/api/v1/mdm/cartypematerial',
      data.type,
      data.data
    )
  },

  // 车型配置手动录入
  insertCartypematerial (data) {
    return axiosData(
      'cc-profile/api/v1/mdm/insertCartypematerial',
      data.type,
      data.data
    )
  },

  //查询配件价格
  componentprice (data) {
    return axiosData(
      'cc-profile/api/v1/mdm/componentprice',
      data.type,
      data.data
    )
  },

  //下载车型模板
  downloadExcelTalbe (data) {
    return axiosData(
      'cc-profile/api/v1/mdm/downloadExcelTalbe',
      data.type,
      data.data
    )
  },

  //车型模板导入
  ModelimportExcel (data) {
    return axiosData('cc-profile/api/v1/mdm/importExcel', data.type, data.data)
  },

  //发送短信
  insertSmsSendRecordList (data) {
    return axiosData(
      'cc-profile/api/v1/sendrecord/insertSmsSendRecordList',
      data.type,
      data.data
    )
  },

  //已发送
  querySmsSendRecordList (data) {
    return axiosData(
      'cc-profile/api/v1/sendrecord/querySmsSendRecordList',
      data.type,
      data.data
    )
  },

  //短信模板配置
  smsTemplatesList (data) {
    return axiosData(
      'cc-task/api/v1/smstemplates/smsTemplatesList',
      data.type,
      data.data
    )
  },

  //联系结果
  querySummaryValue (data) {
    return axiosData(
      'cc-task/api/v1/culcallout/querySummaryValue',
      data.type,
      data.data
    )
  },

  //俱乐部留资有礼详情
  queryClubpoliteProcessesSurvery (data) {
    return axiosData(
      'cc-task/api/v1/clubpolite/queryClubpoliteProcessesSurvery',
      data.type,
      data.data
    )
  },

  //提交
  clubpoliteSubmit (data) {
    return axiosData(
      'cc-task/api/v1/clubpolite/clubpoliteSubmit',
      data.type,
      data.data
    )
  },

  queryRecommendBuyCarList (data) {
    return axiosData(
      'cc-task/api/v1/recommendbuycar/queryRecommendBuyCarList',
      data.type,
      data.data
    )
  },

  addLeads (data) {
    return axiosData('cc-task/api/v1/leads/addLeads', data.type, data.data)
  },

  queryRecommendBuyCarProcessesSurvery (data) {
    return axiosData(
      'cc-task/api/v1/recommendbuycar/queryRecommendBuyCarProcessesSurvery',
      data.type,
      data.data
    )
  },

  selectAllOne1 (data) {
    return axiosData(
      'cc-task/api/v1/clubAppointmentController/selectAllOne',
      data.type,
      data.data
    )
  },

  selectClubAppointmentById (data) {
    return axiosData(
      'cc-task/api/v1/clubAppointmentController/selectClubAppointmentById',
      data.type,
      data.data
    )
  },

  exitVerificationList (data) {
    return axiosData(
      'cc-task/api/v1/exitVerificationController/exitVerificationList',
      data.type,
      data.data
    )
  },

  queryRreplacementVerificationList (data) {
    return axiosData(
      'cc-task/api/v1/replacementVerification/queryRreplacementVerificationList',
      data.type,
      data.data
    )
  },

  queryRreplacementProcessesSurvery (data) {
    return axiosData(
      'cc-task/api/v1/replacementVerification/queryRreplacementProcessesSurvery',
      data.type,
      data.data
    )
  },

  selectExitVerificationById (data) {
    return axiosData(
      'cc-task/api/v1/exitVerificationController/selectExitVerificationById',
      data.type,
      data.data
    )
  },

  temporaryBusinessList (data) {
    return axiosData(
      'cc-task/api/v1/temporaryBusinessController/temporaryBusinessList',
      data.type,
      data.data
    )
  },

  selectTemporaryById (data) {
    return axiosData(
      'cc-task/api/v1/temporaryBusinessController/selectTemporaryById',
      data.type,
      data.data
    )
  },

  //保客列表
  BaokeselBatches (data) {
    return axiosData(
      'cc-task/api/v1/customerprotection/selBatches',
      data.type,
      data.data
    )
  },

  //留资有礼列表
  queryClubpoliteList (data) {
    return axiosData(
      'cc-task/api/v1/clubpolite/queryClubpoliteList',
      data.type,
      data.data
    )
  },

  getMembersAndCustomerProtectionResearch (data) {
    return axiosData(
      'cc-task/api/v1/customerProtectionResearch/getMembersAndCustomerProtectionResearch',
      data.type,
      data.data
    )
  },

  queryTaskInfoTemp (data) {
    return axiosData(
      'cc-task/api/v1/taskInfoTemp/queryTaskInfoTemp',
      data.type,
      data.data
    )
  },

  queryTaskInfoTemp_np (data) {
    return axiosData(
      'cc-task/api/v1/taskInfoTemp/queryTaskInfoTemp_np',
      data.type,
      data.data
    )
  },

  queryMembersAndCustomer (data) {
    return axiosData(
      'cc-task/api/v1/taskInfoTemp/queryMembersAndCustomer',
      data.type,
      data.data
    )
  },

  queryCulcallout (data) {
    return axiosData(
      'cc-task/api/v1/culcallout/queryCulcallout',
      data.type,
      data.data
    )
  },

  queryOneThreeCallout (data) {
    return axiosData(
      'cc-task/api/v1/culcallout/queryOneThreeCallout',
      data.type,
      data.data
    )
  },

  fiveYearsCustomerTask (data) {
    return axiosData(
      'cc-task/api/v1/NewTaskMemberController/fiveYearsCustomerTask',
      data.type,
      data.data
    )
  },

  FulimportExcelTable (data) {
    return axiosData(
      'cc-task/api/v1/customerProtectionResearch/importExcelTable',
      data.type,
      data.data
    )
  },

  queryLeadsProcessesSurvery (data) {
    return axiosData(
      'cc-task/api/v1/culcallout/queryLeadsProcessesSurvery',
      data.type,
      data.data
    )
  },

  //保客新建任务列表
  BaokeList (data) {
    return axiosData(
      'cc-task/api/v1/customerprotection/list',
      data.type,
      data.data
    )
  },

  //保客详情
  selectNewTaskmembersById (data) {
    return axiosData(
      'cc-task/api/v1/outCustomersController/selectOutCustomerById',
      data.type,
      data.data
    )
  },

  //保客提交
  OutCustomerSubmit (data) {
    return axiosData(
      'cc-task/api/v1/outCustomersController/OutCustomerSubmit',
      data.type,
      data.data
    )
  },

  //战败激活列表
  queryDefeatActivatedLeadsList (data) {
    return axiosData(
      'cc-task/api/v1/defeatactivated/queryDefeatActivatedLeadsList',
      data.type,
      data.data
    )
  },

  //战败激活列表
  queryLeadsProcessesSurvery1 (data) {
    return axiosData(
      'cc-task/api/v1/defeatactivated/queryLeadsProcessesSurvery',
      data.type,
      data.data
    )
  },

  //战败激活提交
  defeatactivatedSubmit (data) {
    return axiosData(
      'cc-task/api/v1/defeatactivated/defeatactivatedSubmit',
      data.type,
      data.data
    )
  },

  //工单详情查看问卷
  queryLeadsProcessesSurvery2 (data) {
    return axiosData(
      'cc-task/api/v1/workOrdersController/queryLeadsProcessesSurvery',
      data.type,
      data.data
    )
  },

  //添加短信
  addsmsTemplates (data) {
    return axiosData(
      'cc-task/api/v1/smstemplates/addsmsTemplates',
      data.type,
      data.data
    )
  },

  selectCarCustomer (data) {
    return axiosData(
      'cc-task/api/v1/checkInController/selectCarCustomer',
      data.type,
      data.data
    )
  },

  //提交回访
  WorkOrderSubmit (data) {
    return axiosData(
      'cc-task/api/v1/workOrdersController/WorkOrderSubmit',
      data.type,
      data.data
    )
  },

  deployment (data) {
    return axiosData(
      'cc-task/api/v1/workorder/deployment',
      data.type,
      data.data
    )
  },

  //线索列表
  selBatches (data) {
    return axiosData('cc-task/api/v1/leads/selBatches', data.type, data.data)
  },

  //保客批次详情
  selMembersAndCustomer (data) {
    return axiosData(
      'cc-task/api/v1/customerprotection/selMembersAndCustomer',
      data.type,
      data.data
    )
  },

  //线索信息
  queryLeads (data) {
    return axiosData('cc-task/api/v1/leads/queryLeads', data.type, data.data)
  },

  //线索生成任务
  insertBatchesAndMemberleads (data) {
    return axiosData(
      'cc-task/api/v1/leads/insertBatchesAndMember',
      data.type,
      data.data
    )
  },

  selectNewTaskmembersById2 (data) {
    return axiosData(
      'cc-task/api/v1/NewTaskMemberController/selectNewTaskmembersById',
      data.type,
      data.data
    )
  },

  NewTaskMembersSubmit1 (data) {
    return axiosData(
      'cc-task/api/v1/NewTaskMemberController/NewTaskMembersSubmit',
      data.type,
      data.data
    )
  },

  selectAllOne (data) {
    return axiosData(
      'cc-task/api/v1/NewTaskMemberController/selectAllOne',
      data.type,
      data.data
    )
  },

  //导入批次
  importExcelTable (data) {
    return axiosData(
      'cc-task/api/v1/leads/importExcelTable',
      data.type,
      data.data
    )
  },

  //修改短信
  updatesmsTemplates (data) {
    return axiosData(
      'cc-task/api/v1/smstemplates/updatesmsTemplates',
      data.type,
      data.data
    )
  },

  //修改短信
  getSurveysList (data) {
    return axiosData(
      'cc-task/api/v1/task/surveys/getSurveysList',
      data.type,
      data.data
    )
  },

  //查询工单回访信息
  queryWorkOrder (data) {
    return axiosData(
      'cc-task/api/v1/workorder/queryWorkOrder',
      data.type,
      data.data
    )
  },

  //新增工单回访
  insertBatchesAndMember (data) {
    return axiosData(
      'cc-task/api/v1/workorder/insertBatchesAndMember',
      data.type,
      data.data
    )
  },

  //批次详情
  queryMemberAndLeads (data) {
    return axiosData(
      'cc-task/api/v1/leads/queryMemberAndLeads',
      data.type,
      data.data
    )
  },

  //工单来源
  selectTypeOrPOrderSource (data) {
    return axiosData2(
      'cc-task/api/v1/workorder/selectTypeOrPOrderSource',
      data.type,
      data.data
    )
  },

  //外呼交互日志
  outBoundLogs (data) {
    return axiosData(
      'cc-task/api/v1/pendingController/outBoundLogs',
      data.type,
      data.data
    )
  },

  //查询批次信息
  queryBatches (data) {
    return axiosData2(
      'cc-task/api/v1/workorder/queryBatches',
      data.type,
      data.data
    )
  },

  //查询批次和工单回访详细信息
  queryMemberAndWorkOrder (data) {
    return axiosData(
      'cc-task/api/v1/workorder/queryMemberAndWorkOrder',
      data.type,
      data.data
    )
  },

  //提交
  leadsSubmit (data) {
    return axiosData(
      'cc-task/api/v1/culcallout/leadsSubmit',
      data.type,
      data.data
    )
  },

  //保客挖掘列表
  NewTaskMembersSubmit (data) {
    return axiosData(
      'cc-task/api/v1/outCustomersController/NewTaskMembersSubmit',
      data.type,
      data.data
    )
  },

  //查询用户
  queryAssignUser (data) {
    return axiosData(
      'cc-task/api/v1/workorder/queryAssignUser',
      data.type,
      data.data
    )
  },

  //查询用户
  queryAssignUser2 (data) {
    return axiosData(
      'cc-task/api/v1/workorder/queryAssignUser2',
      data.type,
      data.data
    )
  },

  //确认保存用户
  updateMembersassignUser (data) {
    return axiosData2(
      'cc-task/api/v1/workorder/updateMembersassignUser',
      data.type,
      data.data
    )
  },

  //确认保存用户
  updateMembersassignUser2 (data) {
    return axiosData2(
      'cc-task/api/v1/workorder/updateMembersassignUser2',
      data.type,
      data.data
    )
  },

  //回收
  updateMembers (data) {
    return axiosData2(
      'cc-task/api/v1/workorder/recovery',
      data.type,
      data.data
    )
  },

  queryDefeatActivetedLeads (data) {
    return axiosData2(
      'cc-task/api/v1/defeatactivatedadmin/queryDefeatActivetedLeads',
      data.type,
      data.data
    )
  },

  selectByFileDate (data) {
    return axiosData2(
      'cc-task/api/v1/CarCustomerController/selectByFileDate',
      data.type,
      data.data
    )
  },

  selectByFileDate2 (data) {
    return axiosData2(
      'cc-task/api/v1/CarCustomerController/selectByFileDate2',
      data.type,
      data.data
    )
  },

  selectByFileDate_np (data) {
    return axiosData2(
      'cc-task/api/v1/CarCustomerController/selectByFileDate_np',
      data.type,
      data.data
    )
  },

  selectByFileDate2_np (data) {
    return axiosData2(
      'cc-task/api/v1/CarCustomerController/selectByFileDate2_np',
      data.type,
      data.data
    )
  },

  selectTaskmemberBatchesBystatuss (data) {
    return axiosData2(
      'cc-task/api/v1/CarCustomerController/selectTaskmemberBatchesBystatuss',
      data.type,
      data.data
    )
  },

  selectOneThreeTaskmember (data) {
    return axiosData2(
      'cc-task/api/v1/CarCustomerController/selectOneThreeTaskmember',
      data.type,
      data.data
    )
  },

  selectFiveYearTaskmember (data) {
    return axiosData2(
      'cc-task/api/v1/CarCustomerController/selectFiveYearTaskmember',
      data.type,
      data.data
    )
  },

  //查询批次总数量
  workOrderAssignment (data) {
    return axiosData(
      'cc-task/api/v1/workorder/workOrderAssignment',
      data.type,
      data.data
    )
  },

  //查询批次分配列表
  queryDeploymentUser (data) {
    return axiosData(
      'cc-task/api/v1/workorder/queryDeploymentUser',
      data.type,
      data.data
    )
  },

  //查询批次分配列表
  queryDeploymentUser2 (data) {
    return axiosData(
      'cc-task/api/v1/workorder/queryDeploymentUser2',
      data.type,
      data.data
    )
  },

  //保存潜客
  insertPotentialCustomers (data) {
    return axiosData(
      'cc-task/api/v1/newpotentialcustomers/insertPotentialCustomers',
      data.type,
      data.data
    )
  },

  batchistribution (data) {
    return axiosData(
      'cc-task/api/v1/workorder/batchistribution',
      data.type,
      data.data
    )
  },

  batchDistribution (data) {
    return axiosData(
      'cc-task/api/v1/workorder/batchDistribution',
      data.type,
      data.data
    )
  },

  //调研问卷列表
  surveyslist (data) {
    return axiosData('cc-task/api/v1/task/surveys/list', data.type, data.data)
  },

  //创建问卷
  createSurveys (data) {
    return axiosData(
      'cc-task/api/v1/task/surveys/createSurveys',
      data.type,
      data.data
    )
  },

  //删除问卷
  delSurveys (data) {
    return axiosData(
      'cc-task/api/v1/task/surveys/delSurveys',
      data.type,
      data.data
    )
  },

  //查询问卷
  previewSurveys (data) {
    return axiosData(
      'cc-task/api/v1/task/surveys/previewSurveys',
      data.type,
      data.data
    )
  },

  //修改问卷
  updateSurveys (data) {
    return axiosData(
      'cc-task/api/v1/task/surveys/updateSurveys',
      data.type,
      data.data
    )
  },

  //新增报备
  insertReportprepares (data) {
    return axiosData(
      'cc-task/api/v1/checkInController/insertReportprepares',
      data.type,
      data.data
    )
  },

  //修改问卷
  updateQuestion (data) {
    return axiosData(
      'cc-task/api/v1/task/surveys/updateQuestion',
      data.type,
      data.data
    )
  },

  //工单问卷
  questionnaireSubmit (data) {
    return axiosData(
      'cc-task/api/v1/workOrdersController/questionnaireSubmit',
      data.type,
      data.data
    )
  },

  //救援工单提交
  submitAll (data) {
    return axiosData(
      'cc-task/api/v1/RescueWorkOrderController/submitAll',
      data.type,
      data.data
    )
  },

  //意向车型
  selectMdmCartypematerial (data) {
    return axiosData(
      'cc-task/api/v1/outCustomersController/selectIntendedModels',
      data.type,
      data.data
    )
  },

  //报备
  selectAllList (data) {
    return axiosData(
      'cc-task/api/v1/checkInController/selectAllList',
      data.type,
      data.data
    )
  },

  //工单回访
  selectWorkordersAll (data) {
    return axiosData(
      'cc-task/api/v1/workOrdersController/selectWorkordersAll',
      data.type,
      data.data
    )
  },

  //多号码来电
  checkPhone (data) {
    return axiosData2(
      'cc-workorder/api/v1/workorder/checkPhone',
      data.type,
      data.data
    )
  },

  //多号码来电
  checkPhoneTwo (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/checkPhoneTwo',
      data.type,
      data.data
    )
  },

  //多号码来电
  chooseCustomer (data) {
    return axiosData2(
      'cc-workorder/api/v1/workorder/chooseCustomer',
      data.type,
      data.data
    )
  },

  //工单历史与线索数据列表
  getOrderAndLeadList (data) {
    return axiosData2(
      'cc-workorder/api/v1/workorder/getOrderAndLeadList',
      data.type,
      data.data
    )
  },

  //多号码来电
  reminder (data) {
    return axiosData2(
      'cc-workorder/api/v1/workorder/reminder',
      data.type,
      data.data
    )
  },

  //来电确认
  updatePhones (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/updatePhones',
      data.type,
      data.data
    )
  },

  //
  uploadFile (data) {
    return axiosData(
      'cc-workorder/api/v1/upload/uploadFile',
      data.type,
      data.data
    )
  },

  //交互日志
  updateEndTime (data) {
    return axiosData2(
      'cc-workorder/api/v1/workorder/updateEndTime',
      data.type,
      data.data
    )
  },

  //来电确认
  lookup (data) {
    return axiosData(
      'cc-workorder/api/v1/newcustomercall/lookup',
      data.type,
      data.data
    )
  },

  repeatedComplaints (data) {
    return axiosData2(
      'cc-workorder/api/v1/newcustomercall/repeatedComplaints',
      data.type,
      data.data
    )
  },

  //工单列表
  getOrderList (data) {
    return axiosData(
      'cc-workorder/api/v1/dealOrder/getOrderList',
      data.type,
      data.data
    )
  },

  //工单历史
  orderHistory (data) {
    return axiosData(
      'cc-workorder/api/v1/dealOrder/orderHistory',
      data.type,
      data.data
    )
  },

  //撤回追单催单
  revokeWorkorderOperation (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/revokeWorkorderOperation',
      data.type,
      data.data
    )
  },

  // 追单催单内容修改保存
  saveProcessSuggestionConfir (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/updateWorpess',
      data.type,
      data.data
    )
  },
  //新客户其他保存
  insertOtherCustomer (data) {
    return axiosData(
      'cc-workorder/api/v1/newcustomercall/insertOtherCustomer',
      data.type,
      data.data
    )
  },

  getOrderDetail (data) {
    return axiosData(
      'cc-workorder/api/v1/dealOrder/getOrderDetail',
      data.type,
      data.data
    )
  },

  getOrderDetail2 (data) {
    return axiosData(
      'cc-workorder/api/v1/dealOrder/getOrderDetail2',
      data.type,
      data.data
    )
  },

  updatePhonesTwo (data) {
    return axiosData(
      'cc-workorder/api/v1/newcustomercall/updatePhonesTwo',
      data.type,
      data.data
    )
  },

  chooseCustomer (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/chooseCustomer',
      data.type,
      data.data
    )
  },

  //修改客户
  updateCustomer (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/updateCustomer',
      data.type,
      data.data
    )
  },

  //保存工单
  createStaging (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/createStaging',
      data.type,
      data.data
    )
  },

  //无需派发
  createNotNeedPay (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/createNotNeedPay',
      data.type,
      data.data
    )
  },

  //转faq
  turnFAQ (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/turnFAQ',
      data.type,
      data.data
    )
  },

  //派发工单
  distributionWorkorder (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/distributionWorkorder',
      data.type,
      data.data
    )
  },

  //修改车辆信息
  updateCar (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/updateCar',
      data.type,
      data.data
    )
  },

  //新增新用户
  insertCustomer (data) {
    return axiosData(
      'cc-workorder/api/v1/newcustomercall/insertCustomer',
      data.type,
      data.data
    )
  },
  //首页获取跑马灯数据
  getMarquees (data) {
    return axiosData('cc-user/api/v1/common/getMarquees', data.type, data.data)
  },
  //首页获取工单数据
  getWorkorders (data) {
    return axiosData(
      'cc-user/api/v1/common/getWorkorders',
      data.type,
      data.data
    )
  },
  //待处理左侧导航栏--查询工单列表
  selectAllLeftList (data) {
    return axiosData2(
      'cc-task/api/v1/pendingController/selectWaitDealCount',
      data.type,
      data.data
    )
  },
  //待处理左侧导航栏--查询外呼列表
  selectAllListTask (data) {
    return axiosData(
      'cc-task/api/v1/pendingController/selectAllListTask',
      data.type,
      data.data
    )
  },

  //待处理右侧导航栏--右侧显示具体列表
  selectOrderType (data) {
    return axiosData(
      'cc-task/api/v1/pendingController/selectWaitDealList',
      data.type,
      data.data
    )
  },

  //处理工单
  dealOrderBtns (data) {
    return axiosData(
      'cc-workorder/api/v1/dealOrder/dealOrderBtns',
      data.type,
      data.data
    )
  },

  //工单报备
  reportOrder (data) {
    return axiosData(
      'cc-workorder/api/v1/dealOrder/reportOrder',
      data.type,
      data.data
    )
  },

  //处理工单
  doCancleWork (data) {
    return axiosData(
      'cc-workorder/api/v1/dealOrder/doCancleWork',
      data.type,
      data.data
    )
  },

  //定时抓取提醒条数，弃用
  getUserNoticeCnt (data) {
    return axiosData3(
      'cc-user/api/v1/notice/getUserNoticeCnt',
      data.type,
      data.data
    )
  },
  //定时抓取提醒条数，新
  getNoticeCount (data) {
    return axiosData3(
      'cc-workorder/api/v1/workorder/getNoticeCount',
      data.type,
      data.data
    )
  },

  //回访一级结果
  leadClassificationList (data) {
    return axiosData2(
      'cc-user/api/v1/config/leadClassificationList',
      data.type,
      data.data
    )
  },

  //工单全字段列表
  workOrderTable (data) {
    return axiosData(
      'cc-report-api/api/v1/reportform/workOrderTable',
      data.type,
      data.data
    )
  },

  //2小时回复率列表
  twoHoursOrderTable (data) {
    return axiosData(
      'cc-report-api/api/v1/reportform/twoHoursOrderTable',
      data.type,
      data.data
    )
  },

  //工单全字段列表导出--全部
  workOrderReport (data) {
    return axiosData4(
      'cc-report-api/api/v1/reportform/workOrderReport' + data.params,
      data.type,
      data.data
    )
  },
  //工单全字段列表导出--普通
  workOrderReportNormal (data) {
    return axiosData4(
      'cc-report-api/api/v1/reportform/workOrderReportNormal' + data.params,
      data.type,
      data.data
    )
  },
  //工单列表--抱怨工单导出 TODO
  exportComplainOrder (data) {
    return axiosData4(
      'cc-report-api/api/v1/reportform/exportComplainOrder' + data.params,
      data.type,
      data.data
    )
  },

  //2小时回复率报表导出
  twoHoursOrderReport (data) {
    return axiosData4(
      'cc-report-api/api/v1/reportform/twoHoursOrderReport' + data.params,
      data.type,
      data.data
    )
  },

  //客户档案详情
  passengerCarFieldTable (data) {
    return axiosData(
      'cc-report-api/api/v1/reportform/passengerCarFieldTable',
      data.type,
      data.data
    )
  },
  // 客户档案详情全品牌
  passengerCarFieldTableNew (data) {
    return axiosData(
      'cc-report-api/api/v1/reportform/passengerCarFieldTableNew',
      data.type,
      data.data
    )
  },

  //客户档案详情导出
  passengerCarFieldReport (data) {
    return axiosData4(
      'cc-report-api/api/v1/reportform/passengerCarFieldReport' + data.params,
      data.type,
      data.data
    )
  },

  //客户档案详情导出全品牌
  passengerCarFieldReportNew (data) {
    return axiosData4(
      'cc-report-api/api/v1/reportform/passengerCarFieldReportNew' + data.params,
      data.type,
      data.data
    )
  },

  //外呼任务表头
  outboundCallTaskHeader (data) {
    return axiosData(
      'cc-report-api/api/v1/reportform/outboundCallTaskHeader',
      data.type,
      data.data
    )
  },

  //外呼任务列表
  outboundCallTaskTable (data) {
    return axiosData(
      'cc-report-api/api/v1/reportform/outboundCallTaskTable',
      data.type,
      data.data
    )
  },

  //外呼任务导出
  outboundCallTaskReport (data) {
    return axiosData4(
      'cc-report-api/api/v1/reportform/outboundCallTaskReport' + data.params,
      data.type,
      data.data
    )
  },

  //客服线索报表
  customerServiceTable (data) {
    return axiosData(
      'cc-report-api/api/v1/reportform/customerServiceTable',
      data.type,
      data.data
    )
  },

  //客服线索导出
  customerServiceReport (data) {
    return axiosData4(
      'cc-report-api/api/v1/reportform/customerServiceReport' + data.params,
      data.type,
      data.data
    )
  },

  // 无公告号车辆查询列表
  QnnNumCarTaskTable (data) {
    return axiosData(
      'cc-report-api/api/v1/reportform/QueryNoNotificationNumCarReport',
      data.type,
      data.data
    )
  },

  // 无公告车辆查询列表导出
  QnnNumCarTaskReport (data) {
    return axiosData4(
      'cc-report-api/api/v1/reportform/ExportQueryNoNotificationNumCarReport' + data.params,
      data.type,
      data.data
    )
  },

  //商务车实销查询-表头
  actualSalesTableHeader (data) {
    return axiosData(
      'cc-report-api/api/v1/reportform/actualSalesTableHeader',
      data.type,
      data.data
    )
  },
  //商务车实销查询
  actualSalesTable (data) {
    return axiosData(
      'cc-report-api/api/v1/reportform/actualSalesTable',
      data.type,
      data.data
    )
  },
  //请求手机验证码
  getPhoneCode (data) {
    return axiosData('cc-user/api/v1/auth/sendMsg', data.type, data.data)
  },

  //手机验证码修改密码提交
  changePWByPhoneCode (data) {
    return axiosData('cc-user/api/v1/auth/resetPassword', data.type, data.data)
  },

  //派单错误日志记录
  pushError (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/addTempDistributionLog',
      data.type,
      data.data
    )
  },

  //修改批次名称
  updateBatchesName (data) {
    return axiosData(
      'cc-task/api/v1/leads/updateBatchesName',
      data.type,
      data.data
    )
  },

  //CSI回访
  queryCSIBatches (data) {
    return axiosData(
      'cc-task/api/v1/csiCust/queryCSIBatches',
      data.type,
      data.data
    )
  },

  //CSI回访
  queryCSIMembers (data) {
    return axiosData(
      'cc-task/api/v1/csiCust/queryCSIMembers',
      data.type,
      data.data
    )
  },

  userCSICustList (data) {
    return axiosData(
      'cc-task/api/v1/csiCust/userCSICustList',
      data.type,
      data.data
    )
  },

  getCSICustById (data) {
    return axiosData(
      'cc-task/api/v1/csiCust/getCSICustById',
      data.type,
      data.data
    )
  },

  // 获取坐席今日催单列表
  getWorkorderReminderList (data) {
    return axiosData(
      'cc-user/api/v1/common/getWorkorderReminderList',
      data.type,
      data.data
    )
  },

  selectWarrantyRecommendTaskmember (data) {
    return axiosData2(
      'cc-task/api/v1/CarCustomerController/selectWarrantyRecommendTaskmember',
      data.type,
      data.data
    )
  },

  queryWarrantyRecommend (data) {
    return axiosData(
      'cc-task/api/v1/culcallout/queryWarrantyRecommend',
      data.type,
      data.data
    )
  },

  selectByFileDate3_np (data) {
    return axiosData2(
      'cc-task/api/v1/CarCustomerController/selectByFileDate3_np',
      data.type,
      data.data
    )
  },

  // 实销报表，表格数据查询接口
  salesCarFieldTable (data) {
    return axiosData2(
      'cc-report-api/api/v1/reportform/salesCarFieldTable',
      data.type,
      data.data
    )
  },

  // 实销报表，导出接口
  salesCarFieldReport (data) {
    return axiosData4(
      'cc-report-api/api/v1/reportform/salesCarFieldReport' + data.params,
      data.type,
      data.data
    )
  },

  // 催单记录报表，表格数据查询接口
  orderReminderTable (data) {
    return axiosData2(
      'cc-report-api/api/v1/reportform/orderReminderTable',
      data.type,
      data.data
    )
  },

  // 催单记录报表，导出接口
  orderReminderReport (data) {
    return axiosData4(
      'cc-report-api/api/v1/reportform/orderReminderReport' + data.params,
      data.type,
      data.data
    )
  },

  //项目跟进单全字段列表
  workOrderFollowTable (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/getFollowOrderList',
      data.type,
      data.data
    )
  },
  //项目跟进单导出
  workOrderFollowReport (data) {
    return axiosData4(
      'cc-workorder/api/v1/workorder/exportFollowOrder' + data.params,
      data.type,
      data.data
    )
  },
  //项目跟进单创建
  createFollowOrder (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/createFollowOrder',
      data.type,
      data.data
    )
  },
   //项目跟进单修改
   updFollowOrder (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/updFollowOrder',
      data.type,
      data.data
    )
  },
  //项目跟进单详情
  getFollowOrderDetail (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/getFollowOrderDetail',
      data.type,
      data.data
    )
  },

  //TODO
  //报备导出
  exportPrepares (data) {
    return axiosData4(
      'cc-task/api/v1/checkInController/exportPrepares' + data.params,
      data.type,
      data.data
    )
  },
  //报备车架号查询
  selectCarByVin (data) {
    return axiosData(
      'cc-task/api/v1/checkInController/selectCarByVin',
      data.type,
      data.data
    )
  },
  //舆情模板导出
  exportPublicOpinionExcelTemp (data) {
    return axiosData4(
      'cc-workorder/api/v1/workorder/exportPublicOpinionExcelTemp' + data.params,
      data.type,
      data.data
    )
  },
  //公关舆情任务导出
  exportPublicOpinionExcel (data) {
    return axiosData4(
      'cc-workorder/api/v1/workorder/exportPublicOpinionExcel' + data.params,
      data.type,
      data.data
    )
  },
  //公关舆情任务列表
  getPublicOpinionList (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/getPublicOpinionList',
      data.type,
      data.data
    )
  },
  //舆情任务补充
  savePublicOpinion (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/savePublicOpinion',
      data.type,
      data.data
    )
  },
  //根据条件查询公关舆情任务
  selectPublicOpinionByCondition (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/selectPublicOpinionByCondition',
      data.type,
      data.data
    )
  },
  //查询舆情媒体
  selectOpinionMedia (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/selectOpinionMedia',
      data.type,
      data.data
    )
  },

  //工单详情报表--导出按钮权限查询
  getExportAuthByWorkOrder (data) {
    return axiosData(
       'cc-report-api/api/v1/reportform/getExportAuthByWorkOrder',
      data.type,
      data.data
    )
  },
  //推送智感云
  issCloud (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/issCloud',
      data.type,
      data.data
    )
  },
  //申请延期闭环
  delayClose (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/delayClose',
      data.type,
      data.data
    )
  },
  //审核延期闭环
  checkDelayClose (data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/checkDelayClose',
      data.type,
      data.data
    )
  },
  //查询工单扩展表--暂时只查询抱怨工单是否已审核同意延期闭环
  selectExtendOrder(data) {
    return axiosData(
      'cc-workorder/api/v1/workorder/selectExtendOrder',
      data.type,
      data.data
    )
  },
  //dms取得ticketurl
  selectTicketUrl(data) {
    return axiosData(
      'cc-user/api/v1/dms/selectTicketUrl',
      data.type,
      data.data
    )
  },

}



// WEBPACK FOOTER //
// ./src/api/index.js